var React = require('react');

function AirtimeIconGreenInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.7","cx":"12.5","cy":"12.5","r":"12.5","fill":"#DCFFEC","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.6562 7.9502C10.5517 7.9502 9.65625 8.84563 9.65625 9.95019V15.0502C9.65625 16.1548 10.5517 17.0502 11.6562 17.0502H13.3438C14.4483 17.0502 15.3438 16.1548 15.3438 15.0502V9.9502C15.3438 8.84563 14.4483 7.9502 13.3438 7.9502H11.6562ZM13.6376 15.5541C13.6376 15.4381 13.5436 15.3441 13.4276 15.3441H11.5726C11.4566 15.3441 11.3626 15.4381 11.3626 15.5541V15.7028C11.3626 15.8188 11.4566 15.9128 11.5726 15.9128H13.4276C13.5436 15.9128 13.6376 15.8188 13.6376 15.7028V15.5541Z","fill":"#48D38A","key":1})]);
}

AirtimeIconGreenInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = AirtimeIconGreenInline;

AirtimeIconGreenInline.default = AirtimeIconGreenInline;
